import React from "react"
import HeaderSection from "./FeaturesPage/HeaderSection"
import AppDictionarySection from "./FeaturesPage/AppDictionarySection"
import FeaturesBanners from "./FeaturesPage/FeaturesBanners"
import MoreFeaturesSection from "./FeaturesPage/MoreFeaturesSection"
import StartJourneySection from "./StartJourneySection"

const Features = () => {
  return (
    <div>
      <HeaderSection />
      <AppDictionarySection />
      <FeaturesBanners
        sections={[
          "SynonymsAndAntonymsSection",
          "AudioPronunciationsSection", 
          "OfflineModeSection",
        ]}
      />
      <MoreFeaturesSection />
      <StartJourneySection />
    </div>
  )
}

export default Features
